import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

import * as helpers from './helpers';

export const UCIP = () => {
    useEffect(() => {
        helpers.init();

        window.addEventListener('message', helpers.onMessage);

        return () => {
            window.removeEventListener('message', helpers.onMessage);
        };
    }, []);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.ucip]: UCIP });
